import { defineMessages } from 'react-intl';

const homePageV2Messages = defineMessages({
    homePageV2HeaderTitle: {
        id: 'homePageV2.header.title',
        description: 'Home Page Section heading for title to buy Gift card',
        defaultMessage: 'Buy {brandName} Gift Cards'
    },
    digitalGiftCardTitle: {
        id: 'homePageV2.giftCardCarouselContainer.digitalGiftCard',
        description: 'Home Page carousel section heading for digital gift card container',
        defaultMessage: 'Digital gift cards'
    },
    physicalGiftCardTitle: {
        id: 'homePageV2.giftCardCarouselContainer.physicalGiftCards',
        description: 'Home Page carousel section heading for physical gift card container',
        defaultMessage: 'Physical gift cards'
    },
    bulkGiftCardTitle: {
        id: 'homePageV2.giftCardCarouselContainer.bulkGiftCardTitle',
        description: 'Home Page carousel section heading for bulk / b2b gift card container',
        defaultMessage: 'Buy in bulk'
    },
    digitalGiftCardCTAButtonText: {
        id: 'homePageV2.giftCardCarouselContainer.digitalGiftCardCTAButtonText',
        description: 'Home Page carousel section CTA button text for digital gift card container',
        defaultMessage: 'Buy Digital Gift Cards'
    },
    physicalGiftCardCTAButtonText: {
        id: 'homePageV2.giftCardCarouselContainer.physicalGiftCardCTAButtonText',
        description: 'Home Page carousel section CTA button text for physical gift card container',
        defaultMessage: 'Buy physical gift cards'
    },
    bulkGiftCardCTAButtonText: {
        id: 'homePageV2.giftCardCarouselContainer.bulkGiftCardCTAButtonText',
        description: 'Home Page carousel section CTA button text for bulk b2b gift card container',
        defaultMessage: 'Buy bulk gift cards'
    },
    CurrencyListText: {
        id: 'homePageV2.giftCardCarouselContainer.CurrencyListText',
        description: 'Home Page gift card container Currency List text',
        defaultMessage: 'Available in'
    },
    CurrencyListShowLessText: {
        id: 'homePageV2.giftCardCarouselContainer.CurrencyListShowLessText',
        description: 'Home Page gift card container Currency List Show less text',
        defaultMessage: 'Show less'
    },
    CurrencyListViewAllText: {
        id: 'homePageV2.giftCardCarouselContainer.CurrencyListViewAllText',
        description: 'Home Page gift card container Currency List view all text',
        defaultMessage: 'View all currency'
    },
    ScheduleSendOut: {
        id: 'homePageV2.giftCardDeliveryType.ScheduleSendOut',
        description: '',
        defaultMessage: 'Instant or scheduled email delivery'
    },
    PrintAtHome: {
        id: 'homePageV2.giftCardDeliveryType.PrintAtHome',
        description: '',
        defaultMessage: 'Print at home and deliver yourself'
    },
    ShareViaMessagingApp: {
        id: 'homePageV2.giftCardDeliveryType.ShareViaMessagingApp',
        description: '',
        defaultMessage: 'Share via your favorite messaging app'
    },
    localShippingOut: {
        id: 'homePageV2.giftCardDeliveryType.localShippingOut',
        description: '',
        defaultMessage: 'Ready to ship in 1 to 2 days'
    },
    deliverToYourDoor: {
        id: 'homePageV2.giftCardDeliveryType.deliverToYourDoor',
        description: '',
        defaultMessage: 'A beautiful design, delivered to your door'
    },
    chooseMultipleShippingOption: {
        id: 'homePageV2.giftCardDeliveryType.chooseMultipleShippingOption',
        description: '',
        defaultMessage: 'Free and next day delivery options'
    },
    premiumPackaging: {
        id: 'homePageV2.giftCardDeliveryType.premiumPackaging',
        description: '',
        defaultMessage: 'Elevate your gift with premium packaging'
    },
    CarouselheadingTitle: {
        id: 'homePageV2.categoryFaceplateContainer.CarouselheadingTitle',
        description: 'Home Page gift card container Currency List view all text',
        defaultMessage: 'Choose a Design'
    },
    currencyNotExistsInList: {
        id: 'homePageV2.categoryFaceplateContainer.currencyNotExistsInList',
        description: 'Currency not exists in the currency list',
        defaultMessage: `{cardDeliveryType} gift cards are not available in {selectedCurrency}. Complete your order or remove {selectedCurrency} items from the cart to shop in a different currency.`
    },
    cartCurrencyExists: {
        id: 'homePageV2.categoryFaceplateContainer.cartCurrencyExists',
        description: 'Different Currency exists in Cart',
        defaultMessage: `You are shopping in {selectedCurrency}. Complete your order or remove {selectedCurrency} items from the cart to change currency.\n
        Available {cardDeliveryType} currencies: {currencyList}.`
    },
    digitalDescriptionBullet1: {
        id: 'homePageV2.digitalHighlightBulletLists.descriptionVersion.bullet1',
        description: 'Home Page digital gift card container description version bullet 1',
        defaultMessage: 'Delivered immediately, or choose a date'
    },
    digitalDescriptionBullet2: {
        id: 'homePageV2.digitalHighlightBulletLists.descriptionVersion.bullet2',
        description: 'Home Page digital gift card container description version bullet 2',
        defaultMessage: 'Eco-friendly'
    },
    digitalDescriptionBullet3: {
        id: 'homePageV2.digitalHighlightBulletLists.descriptionVersion.bullet3',
        description: 'Home Page digital gift card container description version bullet 3',
        defaultMessage: 'Email or share a link'
    },
    digitalDescriptionBullet4: {
        id: 'homePageV2.digitalHighlightBulletLists.descriptionVersion.bullet4',
        description: 'Home Page digital gift card container description version bullet 4',
        defaultMessage: 'Customize your gift with a personalized message'
    },
    physicalDescriptionBullet1: {
        id: 'homePageV2.physicalHighlightBulletLists.descriptionVersion.bullet1',
        description: 'Home Page physical gift card container description version bullet 1',
        defaultMessage: 'Standard or express delivery'
    },
    physicalDescriptionBullet2: {
        id: 'homePageV2.physicalHighlightBulletLists.descriptionVersion.bullet2',
        description: 'Home Page physical gift card container description version bullet 2',
        defaultMessage: 'Ready to ship in 1-2 business days'
    },
    physicalDescriptionBullet3: {
        id: 'homePageV2.physicalHighlightBulletLists.descriptionVersion.bullet3',
        description: 'Home Page physical gift card container description version bullet 3',
        defaultMessage: 'A beautiful design, delivered to your door'
    },
    physicalDescriptionBullet4: {
        id: 'homePageV2.physicalHighlightBulletLists.descriptionVersion.bullet4',
        description: 'Home Page physical gift card container description version bullet 4',
        defaultMessage: 'Customize your gift with a personalized message'
    },
    printAtHomeDescriptionBullet1: {
        id: 'homePageV2.printAtHomeHighlightBulletLists.descriptionVersion.bullet1',
        description: 'Home Page print at home gift card container description version bullet 1',
        defaultMessage: 'No shipping required'
    },
    printAtHomeDescriptionBullet2: {
        id: 'homePageV2.printAtHomeHighlightBulletLists.descriptionVersion.bullet2',
        description: 'Home Page print at home gift card container description version bullet 2',
        defaultMessage: 'Hand-deliver immediately'
    },
    printAtHomeDescriptionBullet3: {
        id: 'homePageV2.printAtHomeHighlightBulletLists.descriptionVersion.bullet3',
        description: 'Home Page print at home gift card container description version bullet 3',
        defaultMessage: 'Delivered by email'
    },
    printAtHomeDescriptionBullet4: {
        id: 'homePageV2.printAtHomeHighlightBulletLists.descriptionVersion.bullet4',
        description: 'Home Page print at home gift card container description version bullet 4',
        defaultMessage: 'Customize your gift with a personalized message'
    },
    
    whyChooseEGiftsTitle: {
        id: 'homePageV2.whyChooseEGifts.title',
        description: 'Why choose eGifts section title',
        defaultMessage: 'Why choose eGifts?'
    },
    digitalFeature1Title: {
        id: 'homePageV2.whyChooseDigital.feature1.title',
        description: 'Digital feature 1 title',
        defaultMessage: 'Flexible delivery'
    },
    digitalFeature1Description: {
        id: 'homePageV2.whyChooseDigital.feature1.description',
        description: 'Digital feature 1 description',
        defaultMessage: 'Send it now or choose a delivery time and date.'
    },
    digitalFeature2Title: {
        id: 'homePageV2.whyChooseDigital.feature2.title',
        description: 'Digital feature 2 title',
        defaultMessage: 'Email or share a link'
    },
    digitalFeature2Description: {
        id: 'homePageV2.whyChooseDigital.feature2.description',
        description: 'Digital feature 2 description',
        defaultMessage: 'Send by email or share a link in your favorite messaging app.'
    },
    digitalFeature3Title: {
        id: 'homePageV2.whyChooseDigital.feature3.title',
        description: 'Digital feature 3 title',
        defaultMessage: 'Eco-friendly option'
    },
    digitalFeature3Description: {
        id: 'homePageV2.whyChooseDigital.feature3.description',
        description: 'Digital feature 3 description',
        defaultMessage: 'Delivered digitally, so there’s nothing to print, pack, or post.'
    },
    otherOptionsTitle: {
        id: 'homePageV2.otherOptions.title',
        description: 'Other options section title',
        defaultMessage: 'Other options'
    },
    physicalGiftCardButton: {
        id: 'homePageV2.otherOptions.physicalGiftCard',
        description: 'Physical gift card button text',
        defaultMessage: 'Physical gift card'
    },
    printAtHomeButton: {
        id: 'homePageV2.otherOptions.printAtHome',
        description: 'Print at home button text',
        defaultMessage: 'Print at home'
    },
    DigitalHomeButton: {
        id: 'homePageV2.otherOptions.digitalGiftCard',
        description: 'Digital gift card button text',
        defaultMessage: 'Digital gift card'
    },
    
    whyChoosePhysicalTitle: {
        id: 'homePageV2.whyChoosePhysical.title',
        description: 'Why choose Physical section title',
        defaultMessage: 'Why choose physical gift cards?'
    },
    physicalFeature1Title: {
        id: 'homePageV2.whyChoosePhysical.feature1.title',
        description: 'Physical feature 1 title',
        defaultMessage: 'Ships quickly'
    },
    physicalFeature1Description: {
        id: 'homePageV2.whyChoosePhysical.feature1.description',
        description: 'Physical feature 1 description',
        defaultMessage: 'Your order will be ready to ship in 1–2 business days.'
    },
    physicalFeature2Title: {
        id: 'homePageV2.whyChoosePhysical.feature2.title',
        description: 'Physical feature 2 title',
        defaultMessage: 'Delivery options to suit you'
    },
    physicalFeature2Description: {
        id: 'homePageV2.whyChoosePhysical.feature2.description',
        description: 'Physical feature 2 description',
        defaultMessage: 'Choose from standard or express delivery at checkout.'
    },
    physicalFeature3Title: {
        id: 'homePageV2.whyChoosePhysical.feature3.title',
        description: 'Physical feature 3 title',
        defaultMessage: 'Premium design, delivered'
    },
    physicalFeature3Description: {
        id: 'homePageV2.whyChoosePhysical.feature3.description',
        description: 'Physical feature 3 description',
        defaultMessage: 'A beautifully designed card, delivered by post.'
    },
    
    whyChoosePrintAtHomeTitle: {
        id: 'homePageV2.whyChoosePrintAtHome.title',
        description: 'Why choose Print at Home section title',
        defaultMessage: 'Why choose print at home?'
    },
    printAtHomeFeature1Title: {
        id: 'homePageV2.whyChoosePrintAtHome.feature1.title',
        description: 'Print at Home feature 1 title',
        defaultMessage: 'Less packaging'
    },
    printAtHomeFeature1Description: {
        id: 'homePageV2.whyChoosePrintAtHome.feature1.description',
        description: 'Print at Home feature 1 description',
        defaultMessage: 'No shipping materials required.'
    },
    printAtHomeFeature2Title: {
        id: 'homePageV2.whyChoosePrintAtHome.feature2.title',
        description: 'Print at Home feature 2 title',
        defaultMessage: 'Hand-deliver today'
    },
    printAtHomeFeature2Description: {
        id: 'homePageV2.whyChoosePrintAtHome.feature2.description',
        description: 'Print at Home feature 2 description',
        defaultMessage: 'Perfect for a quick, in-person gift.'
    },
    printAtHomeFeature3Title: {
        id: 'homePageV2.whyChoosePrintAtHome.feature3.title',
        description: 'Print at Home feature 3 title',
        defaultMessage: 'Personal touch'
    },
    printAtHomeFeature3Description: {
        id: 'homePageV2.whyChoosePrintAtHome.feature3.description',
        description: 'Print at Home feature 3 description',
        defaultMessage: 'Hand deliver your gift for a personal touch.'
    },
    loadMoreDesigns: {
        id: 'homePageV2.giftCardCarouselContainer.loadMoreDesigns',
        description: 'Load more designs button label',
        defaultMessage: 'Load more designs'
    },
    showFewerDesigns: {
        id: 'homePageV2.giftCardCarouselContainer.showFewerDesigns',
        description: 'Show fewer designs button label',
        defaultMessage: 'Show fewer designs'
    },
    noInventoryMessage: {
        id: 'homePageV2.giftCardCarouselContainer.noInventoryMessage',
        description: 'No inventory message',
        defaultMessage: 'No inventory available'
    }
});

export default homePageV2Messages;
